import { styledComponent } from '@hermes/web-components'

export const MainContainer = styledComponent('div')<{ open: boolean }>`
  width: 270px;
  position: relative;
  cursor: ${({ open }) => (open ? 'default' : 'pointer')};
  width: 100%;
  `

export const StyledDropDown = styledComponent('div')<{ open: boolean }>`
  border: 1px solid #EAEEFC;
  background: #F4F7FD;
  padding: 8px 16px;
  border-radius: 8px;
  min-height: 40px;
  font-size: 15px;
  color: #112971;
  max-width: 270px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ open }) =>
    `border-radius: ${open ? '8px 8px 0 0' : '8px'};
  border-bottom: 1px solid #EAEEFC;`}
  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
  }
  `

export const HiddenMenu = styledComponent('div')`
  padding: 16px;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  gap: 11px;
  max-height: 300px;
  overflow-y: auto;
  position: absolute;
  z-index: 9;
  width: 100%;
  max-width: 270px;
  justify-content: flex-start;
  border-radius: 0 0 8px 8px;
  border: 1px solid #D5DEF9;
  border-top: none;
  @media (max-width: 768px) {
    max-width: 100%;
  }
  `

export const MenuItem = styledComponent('a')<{ isHospital?: boolean }>`
  background: #EAEEFC;
  border-radius: 16px;
  height: 26px;
  min-height: 26px;
  width: fit-content;
  padding: 2px 12px;
  font-weight: 500;
  font-size: 13px;
  color: #1A3586;
  cursor: pointer;
  white-space: nowrap;
  ${({ isHospital }) =>
    !isHospital &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
  `}
  max-width: 100%;
  text-decoration: none;
  `
